import { ResourceType } from "fond/types/entity";

import { EntityAccessGuard } from "./EntityAccessGuard";

/**
 * HOC factory to create entity-guarded components that check cross-account access
 */
export const withEntityGuard =
  <P extends object>(
    Component: React.ComponentType<P>,
    paramName: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    useGetQuery: (id: string, options?: any) => { data?: any; isLoading: boolean; isError: boolean; error?: any; refetch: () => void },
    resourceType: ResourceType
  ) =>
  // eslint-disable-next-line react/display-name
  (props: P) => {
    return (
      <EntityAccessGuard paramName={paramName} useGetQuery={useGetQuery} resourceType={resourceType}>
        <Component {...props} />
      </EntityAccessGuard>
    );
  };
